import React from 'react';
import { CSVLink } from 'react-csv';
import { useParams } from 'react-router-dom';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import useFetchQlpPlateStatsDownload from '../../Hooks/qlp_ddpcr/useFetchQlpPlateStatsDownload';


const QlpPlateStatsDownLoad = () => {

    const { plate_uuid } = useParams();
    const plateData = useFetchQlpPlateStatsDownload(plate_uuid);
    const parsedData = plateData?.isSuccess ? JSON.parse(plateData?.data) : {};

    const csvData = [];

    // Extract headers
    csvData.push(parsedData?.headers);

    // Extract data rows
    for (const [key, row] of Object.entries(parsedData)) {
        if (key.startsWith("row_")) {
            csvData.push(row);
        }
    }

    // Get QLP filenames from the first data row (QLP_Filename is the first column)
    const qlpFileName = csvData?.length > 1 && csvData[1] && csvData[1][0] ? csvData[1][0] : plate_uuid;
    const csvFileName = qlpFileName ? `${qlpFileName}_stats.csv` : `${plate_uuid}_stats.csv`;

    // Extract headers
    const headers = plateData?.isSuccess ? csvData[0]?.map(header => ({ label: header, key: header })) : [];

    // Prepare rows
    const rows = csvData.slice(1).map(row => {
        return row.reduce((obj, field, index) => {
            obj[headers[index].key] = field;
            return obj;
        }, {});
    });

    const buttonTitleText = plateData?.isLoading ? "Loading data..."
        : plateData?.isSuccess ? "Download CSV Stats"
            : "Error in fetching..";

    return (
        <div className='flex-1'>
            <span />
            <div>
                {plateData?.isSuccess ? (
                    <CSVLink
                        data={rows}
                        headers={headers}
                        filename={csvFileName} // Use QLP filename for better identification
                        className="ml-4 md:ml-8 lg:ml-20 text-center border border-custom-green rounded-[8px]
                                   bg-custom-green text-white px-2 py-1 h-10 font-normal flex items-center justify-center"
                    >
                        <CloudDownloadIcon fontSize="small" /> Csv Stats
                    </CSVLink>
                ) : (
                    <button
                        disabled={true}
                        title={buttonTitleText}
                        className="ml-4 md:ml-8 lg:ml-20 text-center border border-gray-400 rounded-[8px]
                                   bg-gray-400 text-gray-200 px-2 py-1 h-10 font-bold flex items-center 
                                   justify-center cursor-not-allowed"
                    >
                        <CloudDownloadIcon fontSize="small" /> {buttonTitleText}
                    </button>
                )}
            </div>
        </div>

    );
};

export default QlpPlateStatsDownLoad;




